<template>
  <div class="tab">
    <h3>部分数据开放</h3>
    <div>
      <div>
        PYD变量
        <select v-model="selected">
          <option value>请选择变量</option>
          <option v-for="(variable,index) in variableList" :key="index">{{variable.name}}</option>
        </select>
        <span @click="getAnalysis">查看数据分析</span>
      </div>
      <div v-for="(variable,index) in variableList" :key="index">
        <template v-if="getSelectVal == variable.name">
          <div v-for="(img,key) in variable.img" :key="key">
            <img :src="img" />
          </div>
        </template>
      </div>
      <div>
        <p>中国儿童青少年积极发展呢（CPYDS）调查数据取自全国十省（市）、20个 县（区）、60多所中小学学校，部分数据以SPSS格式共享，申请共享请通过电子邮箱联系我们PYD_China@126.com  </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "partialData",
  data() {
    return {
      selected: "",
      variableList: [
        {
          name: "性别",
          img: [require("../../assets/sex.jpg")]
        },
        {
          name: "年龄",
          img: [require("../../assets/age.jpg")]
        },
        {
          name: "区域",
          img: [require("../../assets/area.jpg")]
        },
        {
          name: "潜在剖面类型",
          img: [
            require("../../assets/type1.jpg"),
            require("../../assets/type2.jpg"),
            require("../../assets/type3.jpg")
          ]
        },
        {
          name: "心理健康",
          img: [
            require("../../assets/mental1.jpg"),
            require("../../assets/mental2.jpg"),
            require("../../assets/mental3.jpg")
          ]
        }
      ],
      getSelectVal: ""
    };
  },
  methods: {
    getAnalysis() {
      this.getSelectVal = this.selected;
    }
  }
};
</script>
<style scoped src="../../assets/style/grandchild.css">
/* @import '../assets/style/child.css'; */
</style>




// WEBPACK FOOTER //
// src/components/tabs/partialData.vue